var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo2 = function SvgInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    fillOpacity: 0.5,
    d: "M7 1.313a5.688 5.688 0 1 1 0 11.375A5.688 5.688 0 0 1 7 1.313M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M5.906 9.188a.655.655 0 0 0-.656.656c0 .363.293.656.656.656h2.188a.655.655 0 0 0 .656-.656.655.655 0 0 0-.656-.656h-.219V6.78a.655.655 0 0 0-.656-.656H5.906a.655.655 0 0 0-.656.656c0 .364.293.657.656.657h.657v1.75zM7 5.25A.875.875 0 1 0 7 3.5a.875.875 0 0 0 0 1.75"
  })));
};
export default SvgInfo2;